export const ASSIGN_LIST = 'ASSIGN_LIST';
export const ASSIGN_RELOAD = 'ASSIGN_RELOAD';
export const ASSIGN_CREATE = 'ASSIGN_CREATE';
export const ASSIGN_UPDATE = 'ASSIGN_UPDATE';
export const ASSIGN_APPLY_BASIC = 'ASSIGN_APPLY_BASIC';
export const ASSIGN_UPDATE_STORE_STATUS = 'ASSIGN_UPDATE_STORE_STATUS';
export const ASSIGN_UPDATE_ONLINE_STATUS = 'ASSIGN_UPDATE_ONLINE_STATUS';
export const ASSIGN_CREATE_ADVANCED = 'ASSIGN_CREATE_ADVANCED';
